import {
  POST_SALES_APARTMENT,
  POST_SALES_CORPORATE,
  CAT_BY_PRODUCT,
  CAT_BY_BRAND,
  TAG,
} from "./type";

const initalState = {
  postCorData: [],
  postApartmentData: [],
  getMaterial: [],
  getTag:[],
};

const coporatePostLeadReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case POST_SALES_CORPORATE:
      return {
        ...state,
        postCorData: payload,
      };
    case POST_SALES_APARTMENT:
      return {
        ...state,
        postApartmentData: payload,
      };
    case CAT_BY_PRODUCT:
      return {
        ...state,
        getMaterial: payload,
      };
    case CAT_BY_BRAND:
      return {
        ...state,
        getBrand: payload,
      };
      
    case TAG:
    return {
      ...state,
      getTag: payload,
    };
    default:
      return {
        ...state,
      };
  }
};

export default coporatePostLeadReducer;
